import { t as tuple, I as IMap } from './types-6f6b2fba.js';

const ethereumNetworks = tuple('mainnet', 'homestead', // ethereum mainnet
'goerli', 'kovan', 'rinkeby', 'ropsten', // ethereum testnets
'matic', 'amoy', 'mumbai', // polygon networks
'fuji', 'avax', // avalanche networks
'btc', 'btc-testnet', // bitcoin networks
'klaytn', 'baobab', // klaytn networks
'telos', 'telos-testnet', // telos networks
'sepolia', // new ethereum testnet
'base' // Coinbase network
);
const ethereumNetworkInfo = new IMap([
  ['mainnet', {
      name: 'Ethereum',
      scanner: 'https://etherscan.io',
      chainId: 1,
      logo: 'ethereum',
    }],
  ['homestead', {
      name: 'Ethereum',
      scanner: 'https://etherscan.io',
      chainId: 1,
      logo: 'ethereum',
    }],
  ['goerli', {
      name: 'Goerli',
      scanner: 'https://goerli.etherscan.io',
      chainId: 5,
      logo: 'ethereum',
    }],
  ['ropsten', {
      name: 'Ropsten',
      scanner: 'https://ropsten.etherscan.io',
      chainId: 3,
      logo: 'ethereum',
    }],
  ['rinkeby', {
      name: 'Rinkeby',
      scanner: 'https://rinkeby.etherscan.io',
      chainId: 4,
      logo: 'ethereum',
    }],
  ['kovan', {
      name: 'Kovan',
      scanner: 'https://kovan.etherscan.io',
      chainId: 42,
      logo: 'ethereum',
    }],
  ['matic', {
      name: 'Polygon',
      scanner: 'https://polygonscan.com',
      chainId: 137,
      logo: 'polygon',
    }],
  ['mumbai', {
      name: 'Mumbai',
      scanner: 'https://mumbai.polygonscan.com',
      chainId: 80001,
      logo: 'polygon',
    }],
  ['amoy', {
      name: 'Amoy',
      scanner: 'https://amoy.polygonscan.com',
      chainId: 80002,
      logo: 'polygon',
    }],
  ['fuji', {
      name: 'Fuji',
      scanner: 'https://testnet.snowtrace.io',
      chainId: 43113,
      logo: 'avalanche'
    }],
  ['avax', {
      name: 'AVAX',
      scanner: 'https://snowtrace.io',
      chainId: 43114,
      logo: 'avalanche'
    }],
  ['btc', {
      name: 'Bitcoin',
      scanner: 'https://live.blockcypher.com/btc',
      chainId: 0,
      logo: 'BTC'
    }],
  ['btc-testnet', {
      name: 'Bitcoin testnet',
      scanner: 'https://live.blockcypher.com/btc-testnet',
      chainId: -1,
      logo: 'BTC'
    }],
  ['klaytn', {
      name: 'Klaytn',
      scanner: 'https://klaytnscope.com',
      chainId: 8217,
      logo: 'klaytn'
    }],
  ['baobab', {
      name: 'Baobab testnet',
      scanner: 'https://baobab.klaytnscope.com',
      chainId: 1001,
      logo: 'klaytn'
    }],
  ['telos', {
      name: 'Telos',
      scanner: 'https://www.teloscan.io',
      chainId: 40,
      logo: 'telos'
    }],
  ['telos-testnet', {
      name: 'Telos testnet',
      scanner: 'https://testnet.teloscan.io',
      chainId: 41,
      logo: 'telos'
    }],
  ['sepolia', {
      name: 'Sepolia',
      scanner: 'https://sepolia.etherscan.io',
      chainId: 11155111,
      logo: 'ethereum',
    }],
  ['base', {
      name: 'Base',
      scanner: 'https://basescan.org',
      chainId: 8453,
      logo: 'base',
    }],
]);

export { ethereumNetworkInfo as a, ethereumNetworks as e };
